export const environment = {
  production: true,
  basePath: 'https://api.teletek-cloud.com',
  residorgBasePath: '',
  sitePath: 'https://www.teletek-cloud.com',
  client: 'teletek',
  pacLink: 'https://hca.comelitgroup.com/Account/Authenticated',
  ingeniumLink: 'https://cubikcomelit.ingeniumsl.com'
};
